/* eslint-disable react/jsx-indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-plusplus */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react'

import DateFnsUtils from '@date-io/date-fns'
import {
  Button,
  Grid,
  Typography,
  TableRow,
  TableCell,
  TableFooter,
  Tooltip,
  IconButton,
  MenuItem,
  Menu,
  Checkbox,
  FormControlLabel,
  Link,
} from '@material-ui/core'
import { green, red } from '@material-ui/core/colors'
import { CheckOutlined, CloseOutlined, LocalShipping } from '@material-ui/icons'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import axios from 'axios'
import { es } from 'date-fns/locale'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import { useHistory, useLocation } from 'react-router-dom'

import AttachmentsModal from './AttachmentsModal'
import ChipsReturn from './ChipsReturn'
import DecitionsModal from './DecitionsModal'
import EvidencesModal from './EvidencesModal'
import FiltersBar from './FiltersBar'
import RefundModal from './RefundModal'
import useStyles from './return.styles'
import StatusModal from './StatusModal'

import BackDrop from 'components/BackDrop'
import { EyeIcon, DownloadIcon } from 'components/icons/personalizedIcons'
import useCustomDialogAlert from 'components/useCustomDialogAlert'
import { FILTER_WARRANTIES_VALUE, FILTER_RETACTS_VALUE } from 'constants/filters'
import { AVAILABLE_CHANGES, STATUS_CHANGES } from 'constants/returnsConst'
import { SUPER_ADMIN, DROPSHIPPER, CUSTOMER_SUPPORT } from 'constants/rolesConst'
import { routesLink } from 'constants/routesConsts'
import { API_SELLERS } from 'constants/urls'
import useAuthContext from 'contextApi/AuthContext'
import {
  getByTabAndSellerId,
  getStatusesAdmin,
  changeStatuses,
  getRefundPayments,
  sendRefundPayment,
  changeStatusWithoutAction,
  requestMoreInformation,
} from 'services/Returns'
import convertToCurrencyCop from 'utils/convertToCurrencyCop'
import { textLabels, filterArrayNulls } from 'utils/functions'

const ITEM_HEIGHT = 48

const Returns = () => {
  const showDialogAlert = useCustomDialogAlert()
  const location = useLocation()
  const [filterActive, setFilterActive] = useState()
  const [statusWOAction, setStatusWOAction] = useState({
    isOpen: false,
    returnInfo: null,
    newStatus: '',
  })
  const classes = useStyles()
  const [loading, setLoading] = useState()
  const [tableData, setTableData] = useState({
    data: [],
    totalRows: 0,
  })
  const [tabs, setTabs] = useState([])
  const history = useHistory()

  const [statusList, setStatusList] = useState([])
  const [refundPayments, setRefundPayments] = useState([])
  const [sellers, setSellers] = useState([])
  const [confirmationData, setConfirmationData] = useState()
  const [evidencesData, setEvidencesData] = useState()
  const [isOpenChange, setIsOpenChange] = useState({
    isOpen: false,
    decition: true,
  })
  const [showTooltip, setShowTooltip] = useState(false)
  const [isOpenRefundModal, setIsOpenRefundModal] = useState({
    isOpen: false,
    data: {},
  })
  const [isEvidenceOpen, setIsEvidenceOpen] = useState(false)
  const [isOpenAttachments, setIsOpenAttachments] = useState({
    isOpen: false,
    files: [],
  })
  const [request, setRequest] = useState({
    tabs: [10],
    sellerId: null,
    filters: [
      {
        type: 3,
        value: FILTER_WARRANTIES_VALUE,
      },
      {
        type: 3,
        value: FILTER_RETACTS_VALUE,
      },
    ],
    orderType: 0,
    page: 1,
    size: 10,
  })
  const [customFilter, setCustomFilter] = useState({
    type: 0,
    value: null,
  })
  const [filterList, setFilterList] = useState([])

  const { userLoggedin, updateReturnsCount } = useContext(useAuthContext)
  const hasSuperAdminRole = [SUPER_ADMIN, CUSTOMER_SUPPORT].includes(userLoggedin.role)
  const [date, setDate] = useState({
    initialDate: null,
    finalDate: new Date(),
  })

  const getReturnsByFilter = async (data) => {
    setLoading(true)
    const requestData = { ...data }
    if (data.dateFrom && data.dateTo) {
      requestData.dateFrom = data.dateFrom
      requestData.dateTo = data.dateTo
    }
    try {
      const result = await getByTabAndSellerId({
        ...requestData,
        orderType: 0,
      })
      setTableData({
        data: result.data,
        totalRows: result.totalRows,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const getTabStatuses = async () => {
    const query = new URLSearchParams(location.search)
    const uniqueId = Number(query.get('uniqueId'))
    setLoading(true)
    try {
      const { data } = await getStatusesAdmin()
      if (data) {
        setTabs(data)
        if (uniqueId && uniqueId !== 0) {
          const filterRefund = data.find((item) => item.uniqueId === uniqueId)
          setRequest({
            ...request,
            page: 1,
            tabs: filterRefund.children.map((child) => child.uniqueId),
            filters: filterList.map((f) => ({
              type: f.type,
              value: String(f.value),
            })),
          })
          setFilterActive(filterRefund)
        } else {
          setFilterActive(filterActive ?? data[0])
        }

        const filtered = []
        data.forEach((element) => {
          filtered.push(...element.children)
        })
        setStatusList(filtered)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const getRefundPaymentsList = async () => {
    setLoading(true)
    try {
      const { data } = await getRefundPayments()
      setRefundPayments(data)
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  const getSellers = (total = 30000) => {
    axios
      .get(`${API_SELLERS}?sellerFilterType=1&pageSize=${total}`)
      .then((response) => {
        setLoading(false)
        if (response) {
          // eslint-disable-next-line radix
          if (response.data.pagination.totalCount > parseInt(total)) {
            getSellers(response.pagination.totalCount)
          } else {
            const filterData = filterArrayNulls(response.data.data, 'userName')
            setSellers(filterData)
          }
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  const getInitialLoad = async () => {
    await getTabStatuses()
    await getRefundPaymentsList()
    if (hasSuperAdminRole) {
      getSellers()
    }
  }

  const onCheckStatusChange = async (data, decition, comments) => {
    setLoading(true)
    const parentStatus = AVAILABLE_CHANGES.find((item) => item.uniqueId === filterActive.uniqueId)
    const childStatus = parentStatus.availableChanges.find((item) => item.decition === decition)
    const detailStatus = statusList.find((item) => item.uniqueId === childStatus.uniqueId)
    const body = {
      returnId: data.returnId,
      detailsStatuses: data.detailIds.map((detailId) => ({
        detailId,
        detailStatus,
        description: comments,
      })),
      user: {
        name: userLoggedin.name,
        email: userLoggedin.email,
      },
    }
    changeStatuses(body).then((response) => {
      if (response.isSuccessful) {
        showDialogAlert(
          true,
          'Cambio de estado',
          'El cambio de estado se realizó correctamente',
          'Aceptar',
          ''
        )
      } else {
        showDialogAlert(true, 'Cambio de estado', response.message, 'Aceptar', '')
      }
      getReturnsByFilter(request).then(() => {
        getTabStatuses()
        updateReturnsCount()
        setLoading(false)
      })
    })
  }

  const handleRefundPayment = async (
    returnId,
    returnDetailId,
    refundType,
    refundUniqueId,
    productName
  ) => {
    setLoading(true)
    const data = {
      returnId,
      returnDetailId,
      refundType,
      refundUniqueId,
    }

    const response = await sendRefundPayment(data)
    if (!response.isSuccessful) {
      if (refundUniqueId === 1) {
        setIsOpenRefundModal({
          isOpen: true,
          data: { ...data, productName },
        })
      } else {
        showDialogAlert(
          true,
          'Reembolso fallido',
          'Ha ocurrido un problema al realizar el reembolso, por favor intente nuevamente o comuníquese con el administrador.',
          'Aceptar',
          ''
        )
      }
      setLoading(false)
    } else {
      showDialogAlert(
        true,
        refundUniqueId === 1 ? 'Producto creado nuevamente' : 'Solicitud de reembolso creada',
        refundUniqueId === 1
          ? 'El producto fue creado nuevamente en la orden sujeta a la solicitud de devolución, puede revisar la orden para verificar el cambio. Si presenta algún inconveniente por favor comuníquese con el administrador.'
          : 'El reembolso de dinero será solicitado a la entidad financiera involucrada, por favor espere a que el proceso sea completado. Si presenta algún inconveniente por favor comuníquese con el administrador.',
        'Aceptar',
        ''
      )
      getReturnsByFilter(request).then(() => {
        setLoading(false)
      })
    }
  }
  const handleNewFilter = (e) => {
    if (e) {
      e.preventDefault()
    }
    if (date.initialDate && date.finalDate) {
      const dateFrom = moment(date.initialDate).toISOString()
      const dateTo = moment(date.finalDate).toISOString()
      setRequest({
        ...request,
        dateFrom: dateFrom,
        dateTo: dateTo,
      })
    }
    if (customFilter.value || (customFilter.type === 4 && date.initialDate && date.finalDate)) {
      // eslint-disable-next-line no-nested-ternary
      const name = customFilter.type === 1 ? 'Orden' : 'Estado de orden'
      const addFilter = filterList.some((f) => f.type === customFilter.type)
      if (addFilter) {
        const newFilters = filterList.filter((f) => f.type !== customFilter.type)
        setFilterList([...newFilters, { name, type: customFilter.type, value: customFilter.value }])
        const custom = request.filters.find((filter) => filter.type === customFilter.type)
        let requestFilters = [
          ...newFilters,
          ...request.filters.filter((f) => f.type !== customFilter.type), // ⬅️ elimina el anterior con mismo tipo
          { type: customFilter.type, value: String(customFilter.value) }, // ⬅️ agrega el nuevo
        ]
        if (custom) {
          requestFilters = [
            ...newFilters,
            ...request.filters.filter((f) => f.type !== customFilter.type),
            { type: customFilter.type, value: String(customFilter.value) },
          ]
        }
        setRequest((prev) => ({
          ...prev,
          page: 1,
          filters: requestFilters,
        }))
      } else {
        setFilterList([...filterList, { name, type: customFilter.type, value: customFilter.value }])
        setRequest({
          ...request,
          page: 1,
          filters: [
            ...filterList,
            ...request.filters,
            { type: customFilter.type, value: String(customFilter.value) },
          ],
        })
      }
      setCustomFilter({
        value: '',
        type: 0,
      })
    }
  }

  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleDecitionClick = (tableMeta, decition) => {
    const returnData = tableData.data.find((item) =>
      item.returnDetails.find((detail) => detail.id === tableMeta.rowData[0])
    )
    const returnDetail = returnData.returnDetails.find((item) => item.id === tableMeta.rowData[0])

    const ultData = {
      returnId: returnData.returnId,
      detailIds: [returnDetail.id],
      returnInfo: returnData,
      productStatusId: returnDetail.productStatusId,
    }
    setConfirmationData(ultData)
    setIsOpenChange({
      isOpen: true,
      decition,
    })
  }

  const handleStatusChangeWOAction = (returnData, newStatus, description) => {
    setLoading(true)
    changeStatusWithoutAction({
      returnId: returnData.returnId,
      detailsStatuses: [
        {
          description,
          detailId: returnData.returnDetails.id,
          detailStatus: newStatus,
        },
      ],
      user: {
        name: userLoggedin.name,
        email: userLoggedin.email,
      },
    }).then((response) => {
      if (response.isSuccessful) {
        showDialogAlert(
          true,
          'Cambio de estado',
          'El cambio de estado se realizó correctamente',
          'Aceptar',
          ''
        )
      } else {
        showDialogAlert(true, 'Cambio de estado', response.message, 'Aceptar', '')
      }
      getReturnsByFilter(request).then(() => {
        getTabStatuses()
        updateReturnsCount()
        setLoading(false)
      })
    })
  }
  const handleCheckWarrantiesAndRetacts = (type, value, checked) => {
    setShowTooltip(false)
    const stringValue = value.toString()
    const oppositeValue =
      stringValue === FILTER_RETACTS_VALUE ? FILTER_WARRANTIES_VALUE : FILTER_RETACTS_VALUE
    const hasOppositeValue = request.filters.some(
      (filter) => filter.value === oppositeValue && filter.type === 3
    )

    if (!hasOppositeValue) {
      setShowTooltip(true)
      return
    }

    const updatedFilters = checked
      ? [...request.filters, { type, value: stringValue }]
      : request.filters.filter((filter) => !(filter.type === type && filter.value === stringValue))
    setRequest({
      ...request,
      filters: updatedFilters,
    })
  }
  const handleRequestInfo = async (data) => {
    setLoading(true)
    requestMoreInformation({
      ...data,
      user: userLoggedin.firstName,
    })
      .then((res) => {
        if (res.isSuccessful) {
          showDialogAlert(
            true,
            'Cambio de estado',
            'El cambio de estado se realizó correctamente',
            'Aceptar',
            ''
          )
        } else {
          showDialogAlert(true, 'Cambio de estado', res.message, 'Aceptar', '')
        }
        getReturnsByFilter(request).then(() => {
          getTabStatuses()
          updateReturnsCount()
          setLoading(false)
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const mergeFilters = (existingFilters, newFilters) => {
    const result = [...existingFilters]

    newFilters.forEach((newFilter) => {
      const exists = result.some((f) => f.type === newFilter.type && f.value === newFilter.value)

      if (!exists) {
        result.push(newFilter)
      }
    })

    return result
  }
  useEffect(() => {
    getInitialLoad()
  }, [])

  useEffect(() => {
    getReturnsByFilter(request)
  }, [request])
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
      <BackDrop open={loading} />
      <Typography variant="h6" style={{ color: '#6064FF' }}>
        Listado de devoluciones
      </Typography>
      <Grid container spacing={3} alignItems="center">
        {tabs.map((tab) => {
          if (tab.uniqueId === 6 && !hasSuperAdminRole) {
            return null
          }
          return (
            <Grid item key={tab.name}>
              <div className={classes.fltContainer}>
                {tab.returnQuantity > 0 && (
                  <div className={classes.quantityLabel}>{tab.returnQuantity}</div>
                )}
                {filterActive?.uniqueId === tab.uniqueId ? (
                  <Button className={classes.btnActive} variant="outlined">
                    {tab.name}
                  </Button>
                ) : (
                  <Button
                    className={classes.btnNotActive}
                    variant="outlined"
                    onClick={() => {
                      setFilterActive(tab)
                      const RequestAndfilters = filterList.map((f) => ({
                        type: f.type,
                        value: String(f.value),
                      }))
                      const mergedFilters = mergeFilters(request.filters, RequestAndfilters)
                      setRequest({
                        ...request,
                        page: 1,
                        tabs: tab.children.map((t) => t.uniqueId),
                        filters: mergedFilters,
                      })
                    }}
                  >
                    {tab.name}
                  </Button>
                )}
              </div>
            </Grid>
          )
        })}
      </Grid>
      <br />
      <Grid container direction="column" xs={12}>
        <Grid item xs={12}>
          <span>Filtros</span>
          <br />
          <FiltersBar
            customFilter={customFilter}
            setCustomFilter={setCustomFilter}
            request={request}
            handleCheckWarrantiesAndRetacts={handleCheckWarrantiesAndRetacts}
            handleNewFilter={handleNewFilter}
            setDate={setDate}
            date={date}
          />
        </Grid>
        <Grid item xs={12}>
          <ChipsReturn
            request={request}
            setRequest={setRequest}
            setDate={setDate}
            sellers={sellers}
            filterList={filterList}
            getReturnsByFilter={getReturnsByFilter}
            setFilterList={setFilterList}
          />
        </Grid>
        <Grid item xs={12}>
          <MUIDataTable
            data={tableData.data}
            options={{
              print: false,
              filter: false,
              download: false,
              viewColumns: false,
              serverSide: true,
              expandableRows: true,
              search: false,
              sort: false,
              count: tableData.totalRows,
              onChangePage: (currentPage) => {
                setRequest((prevState) => ({
                  ...prevState,
                  page: currentPage + 1,
                }))
              },
              onChangeRowsPerPage: (rows) => {
                setRequest((prevState) => ({
                  ...prevState,
                  size: rows,
                }))
              },
              page: request.page - 1,
              tableBodyMaxHeight: '70vh',
              tableBodyHeight: '65vh',
              expandableRowsHeader: false,
              textLabels: textLabels(loading),
              selectableRows: 'none',
              fixedHeader: true,
              renderExpandableRow: (rowData) => {
                const colSpan = rowData.length + 1
                const { returnDetails } = tableData.data.find((row) => row.returnId === rowData[0])
                return (
                  <TableRow>
                    <TableCell
                      colSpan={colSpan}
                      style={{ backgroundColor: 'white', padding: '2%', paddingTop: '5px' }}
                    >
                      <MUIDataTable
                        options={{
                          print: false,
                          filter: false,
                          download: false,
                          viewColumns: false,
                          search: false,
                          sort: false,
                          selectableRows: returnDetails.length > 1 ? 'multiple' : 'none',
                          textLabels: textLabels(loading),
                          customFooter: () => <TableFooter />,
                        }}
                        data={returnDetails}
                        columns={[
                          {
                            name: 'id',
                            label: '',
                            options: {
                              display: false,
                            },
                          },
                          {
                            name: 'orderDetailId',
                            label: '',
                            options: {
                              display: 'hidden',
                              customHeadLabelRender: () => {
                                return (
                                  <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                    LINEA DE PRODUCTO
                                  </th>
                                )
                              },
                            },
                          },
                          {
                            name: 'productName',
                            label: '',
                            options: {
                              customHeadLabelRender: () => {
                                return (
                                  <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                    PRODUCTO
                                  </th>
                                )
                              },
                              customBodyRender: (value) => {
                                return (
                                  <Link
                                    href={`${routesLink.products}?product=${value}`}
                                    color="secondary"
                                    onClick={(event) => {
                                      event.preventDefault()
                                      history.push(`${routesLink.products}?product=${value}`)
                                    }}
                                  >
                                    <Typography variant="body1" style={{ marginLeft: '5%' }}>
                                      {value}
                                    </Typography>
                                  </Link>
                                )
                              },
                            },
                          },
                          {
                            name: 'productStatusName',
                            label: '',
                            options: {
                              customHeadLabelRender: () => {
                                return (
                                  <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                    ESTADO DE ORDEN
                                  </th>
                                )
                              },
                              customBodyRender: (value) => {
                                return (
                                  <div style={{ fontFamily: 'Red Hat Display Regular' }}>
                                    {value || 'N/A'}
                                  </div>
                                )
                              },
                            },
                          },
                          {
                            name: 'refundSelected',
                            label: '',
                            options: {
                              customHeadLabelRender: () => {
                                return (
                                  <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                    METODO DE REEMBOLSO PREFERIDO
                                  </th>
                                )
                              },
                              customBodyRender: (value) => {
                                return (
                                  <div style={{ fontFamily: 'Red Hat Display Regular' }}>
                                    {value.type}
                                  </div>
                                )
                              },
                            },
                          },
                          {
                            name: 'productPrice',
                            label: '',
                            options: {
                              customHeadLabelRender: () => {
                                return (
                                  <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                    VALOR UNITARIO
                                  </th>
                                )
                              },
                              customBodyRender: (value) => {
                                return (
                                  <div style={{ fontFamily: 'Red Hat Display Regular' }}>
                                    {`$${convertToCurrencyCop(Number(value))}`}
                                  </div>
                                )
                              },
                            },
                          },
                          {
                            name: 'attachments',
                            label: '',
                            options: {
                              customHeadLabelRender: () => (
                                <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                  OBSERVACIONES
                                </th>
                              ),

                              customBodyRender: (value, tableMeta) => {
                                return (
                                  <Grid container direction="row" spacing={1}>
                                    <Grid item>
                                      <Tooltip title="Ver observaciones">
                                        <IconButton
                                          style={{
                                            margin: '0 0 0 40%',
                                          }}
                                          onClick={() => {
                                            const returnData = tableData.data.find((item) =>
                                              item.returnDetails.find(
                                                (detail) => detail.id === tableMeta.rowData[0]
                                              )
                                            )
                                            const returnDetail = returnData.returnDetails.find(
                                              (item) => item.id === tableMeta.rowData[0]
                                            )
                                            setEvidencesData(() => ({
                                              returnDetail,
                                              returnData,
                                            }))
                                            setIsEvidenceOpen(true)
                                          }}
                                        >
                                          <EyeIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                )
                              },
                            },
                          },
                          {
                            name: 'download',
                            label: '',
                            options: {
                              customHeadLabelRender: () => (
                                <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                  ADJUNTOS
                                </th>
                              ),
                              customBodyRender: (value, tableMeta) => {
                                return (
                                  <Grid container direction="row" spacing={1}>
                                    <Grid item>
                                      <Tooltip title="Descargar adjuntos">
                                        <IconButton
                                          style={{
                                            margin: '0 0 0 40%',
                                          }}
                                          disabled={tableMeta.rowData[6].length === 0}
                                          onClick={() => {
                                            const returnData = tableData.data.find((item) =>
                                              item.returnDetails.find(
                                                (detail) => detail.id === tableMeta.rowData[0]
                                              )
                                            )
                                            const returnDetail = returnData.returnDetails.find(
                                              (item) => item.id === tableMeta.rowData[0]
                                            )
                                            setIsOpenAttachments({
                                              isOpen: true,
                                              files: returnDetail.attachments,
                                            })
                                          }}
                                        >
                                          <DownloadIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                )
                              },
                            },
                          },
                          {
                            name: 'guideReturn',
                            label: '',
                            options: {
                              display: returnDetails[0].guideReturn?.guideUrl ? 'true' : 'false',
                              customHeadLabelRender: () => (
                                <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                  GUÍA DE DEVOLUCIÓN
                                </th>
                              ),
                              customBodyRender: (value) => {
                                return (
                                  <Grid container direction="row" spacing={1}>
                                    <Grid item>
                                      <Tooltip title="Descargar guía">
                                        <IconButton
                                          style={{
                                            borderRadius: '1rem',
                                          }}
                                          onClick={() => {
                                            window.open(value?.guideUrl, '_blank')
                                          }}
                                        >
                                          <LocalShipping />
                                          <Typography
                                            variant="body1"
                                            style={{
                                              marginLeft: '5%',
                                              fontFamily: 'Red Hat Display Regular',
                                            }}
                                          >
                                            {value?.number}
                                          </Typography>
                                        </IconButton>
                                      </Tooltip>
                                    </Grid>
                                  </Grid>
                                )
                              },
                            },
                          },
                          {
                            name: 'returnDate',
                            label: 'Fecha de recogida',
                            options: {
                              display: returnDetails[0].guideReturn?.guideUrl ? 'true' : 'false',
                              customHeadLabelRender: () => (
                                <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                  FECHA DE RECOGIDA
                                </th>
                              ),
                              customBodyRender: (value, tableMeta) => {
                                const guideReturn = tableMeta.rowData[8]
                                const pickUpDate = guideReturn?.pickUpDate?.split(' ')[0]
                                const pickUpRangeTime = guideReturn?.pickUpRangeTime
                                const guideDate = pickUpDate
                                  ? `${pickUpDate} | ${pickUpRangeTime}`
                                  : 'N/A'
                                return (
                                  <div style={{ fontFamily: 'Red Hat Display Regular' }}>
                                    {guideDate}
                                  </div>
                                )
                              },
                            },
                          },
                          {
                            name: 'decitions',
                            label: '',
                            options: {
                              display: [1, 2].includes(filterActive.uniqueId),
                              customHeadLabelRender: () => (
                                <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                  DECISION
                                </th>
                              ),
                              customBodyRender: (value, tableMeta) => {
                                const disabled =
                                  (hasSuperAdminRole && filterActive.uniqueId === 1) ||
                                  (userLoggedin.role === DROPSHIPPER && filterActive.uniqueId === 2)
                                return (
                                  <Grid container direction="row" spacing={1}>
                                    <Tooltip title="Aprobar">
                                      <IconButton
                                        disabled={disabled}
                                        onClick={() => {
                                          handleDecitionClick(tableMeta, true)
                                        }}
                                      >
                                        <CheckOutlined
                                          style={{ color: disabled ? 'gray' : green[500] }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Rechazar">
                                      <IconButton
                                        disabled={disabled}
                                        onClick={() => {
                                          handleDecitionClick(tableMeta, false)
                                        }}
                                      >
                                        <CloseOutlined
                                          style={{ color: disabled ? 'gray' : red[500] }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Grid>
                                )
                              },
                            },
                          },
                          {
                            name: 'productReceivedByCarrier',
                            label: '',
                            options: {
                              display: 'false',
                            },
                          },
                          {
                            name: 'productDeliveredByCarrier',
                            label: '',
                            options: {
                              display: 'false',
                            },
                          },
                          {
                            name: 'carrier',
                            label: 'TRANSPORTADORA',
                            options: {
                              display: [3].includes(filterActive.uniqueId) && false,
                              customHeadLabelRender: () => (
                                <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                                  TRANSPORTADORA
                                </th>
                              ),
                              customBodyRender: (value, tableMeta) => {
                                return (
                                  <Grid container direction="column">
                                    <Grid item>
                                      <FormControlLabel
                                        disabled
                                        control={<Checkbox checked={tableMeta.rowData[5]} />}
                                        label="Producto recogido"
                                      />
                                    </Grid>
                                    <Grid item>
                                      <FormControlLabel
                                        disabled
                                        control={<Checkbox checked={tableMeta.rowData[6]} />}
                                        label="Producto entregado"
                                      />
                                    </Grid>
                                  </Grid>
                                )
                              },
                            },
                          },
                          {
                            name: 'approveActions',
                            label: '',
                            options: {
                              display:
                                (filterActive.uniqueId === 2 && hasSuperAdminRole) ||
                                filterActive.uniqueId === 3,
                              customHeadLabelRender: () => (
                                <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }} />
                              ),
                              customBodyRender: (value, tableMeta) => {
                                const returnData = tableData.data.find((item) =>
                                  item.returnDetails.find(
                                    (detail) => detail.id === tableMeta.rowData[0]
                                  )
                                )
                                const returnDetail = returnData.returnDetails.find(
                                  (item) => item.id === tableMeta.rowData[0]
                                )
                                return (
                                  <div>
                                    <IconButton
                                      aria-label="more"
                                      aria-controls="long-menu"
                                      aria-haspopup="true"
                                      onClick={handleClick}
                                    >
                                      <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                      id="long-menu"
                                      anchorEl={anchorEl}
                                      keepMounted
                                      open={open}
                                      onClose={handleClose}
                                      PaperProps={{
                                        style: {
                                          maxHeight: ITEM_HEIGHT * 4.5,
                                          width: '38ch',
                                          boxShadow: '-6px 6px #E8E8E8',
                                          fontFamily: 'Red Hat Display Regular',
                                        },
                                      }}
                                    >
                                      {filterActive.uniqueId === 2 && (
                                        <MenuItem
                                          onClick={() => {
                                            handleRequestInfo({
                                              returnId: returnData.returnId,
                                              returnDetailId: returnDetail.id,
                                            })
                                            handleClose()
                                          }}
                                        >
                                          Solicitar mas evidencias
                                        </MenuItem>
                                      )}
                                      {filterActive.uniqueId === 3 &&
                                        refundPayments.map((option) => {
                                          if (
                                            (option.uniqueId === 1 &&
                                              returnDetail.reasonReturn.id === 3) ||
                                            (option.uniqueId === 2 &&
                                              returnDetail.reasonReturn.id === 1)
                                          )
                                            return null
                                          return (
                                            <MenuItem
                                              key={option.id}
                                              onClick={() => {
                                                handleRefundPayment(
                                                  returnData.returnId,
                                                  returnDetail.id,
                                                  option.type,
                                                  option.uniqueId,
                                                  returnDetail.productName
                                                )
                                                handleClose()
                                              }}
                                            >
                                              {option.type}
                                            </MenuItem>
                                          )
                                        })}
                                      {hasSuperAdminRole &&
                                        (filterActive.uniqueId === 2 ? (
                                          <MenuItem
                                            onClick={() => {
                                              setStatusWOAction({
                                                returnInfo: {
                                                  ...returnData,
                                                  returnDetails: returnDetail,
                                                },
                                                isOpen: true,
                                                newStatus: {
                                                  uniqueId: 60,
                                                  name: 'Archivado',
                                                },
                                              })
                                              handleClose()
                                            }}
                                          >
                                            Mover a Archivado
                                          </MenuItem>
                                        ) : (
                                          STATUS_CHANGES.map((option) => {
                                            return (
                                              <MenuItem
                                                key={option.uniqueId}
                                                onClick={() => {
                                                  setStatusWOAction({
                                                    returnInfo: {
                                                      ...returnData,
                                                      returnDetails: returnDetail,
                                                    },
                                                    isOpen: true,
                                                    newStatus: option,
                                                  })
                                                  handleClose()
                                                }}
                                              >
                                                {`Mover a ${option.name}`}
                                              </MenuItem>
                                            )
                                          })
                                        ))}
                                    </Menu>
                                  </div>
                                )
                              },
                            },
                          },
                        ]}
                      />
                    </TableCell>
                  </TableRow>
                )
              },
            }}
            columns={[
              {
                name: 'returnId',
                label: '',
                options: { display: false },
              },
              {
                name: 'orderNumber',
                label: '',
                options: {
                  customHeadLabelRender: () => {
                    return (
                      <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                        NÚMERO DE ORDEN
                      </th>
                    )
                  },
                  customBodyRender: (value) => {
                    return (
                      <Link
                        href={`${routesLink.viewOrder}/${value}`}
                        color="secondary"
                        onClick={(event) => {
                          event.preventDefault()
                          history.push(`${routesLink.viewOrder}/${value}`)
                        }}
                      >
                        <Typography variant="body1" style={{ marginLeft: '5%' }}>
                          {value}
                        </Typography>
                      </Link>
                    )
                  },
                },
              },
              {
                name: 'orderPaymentMethods',
                label: '',
                options: {
                  customHeadLabelRender: () => {
                    return (
                      <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                        MEDIO DE PAGO USADO
                      </th>
                    )
                  },
                },
              },
              {
                name: 'returnDetails',
                label: '',
                options: {
                  customHeadLabelRender: () => {
                    return (
                      <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                        RAZÓN DE DEVOLUCION
                      </th>
                    )
                  },
                  customBodyRender: (value) => {
                    return (
                      <div>
                        {`${value[0].reasonReturn.type}: ${value[0].reasonReturn.optionSelected}`}
                      </div>
                    )
                  },
                },
              },
              {
                name: 'sellerName',
                label: '',
                options: {
                  display: hasSuperAdminRole,
                  customHeadLabelRender: () => {
                    return (
                      <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>TIENDA</th>
                    )
                  },
                },
              },
              {
                name: 'status',
                label: '',
                options: {
                  customHeadLabelRender: () => {
                    return (
                      <th style={{ fontFamily: 'Red Hat Display Black', fontSize: 13 }}>
                        ESTADO DE DEVOLUCIÓN
                      </th>
                    )
                  },
                  customBodyRender: (value, tableMeta) => {
                    const uniqueStatusNames = [
                      ...new Set(tableMeta.rowData[3].map((item) => item.status.name)),
                    ]
                    const statusString = uniqueStatusNames.join(' - ')
                    return statusString
                  },
                },
              },
            ]}
          />
        </Grid>
      </Grid>

      <EvidencesModal
        returnInfo={evidencesData}
        isOpen={isEvidenceOpen}
        handleClose={() => {
          setIsEvidenceOpen(false)
        }}
      />
      <AttachmentsModal
        isOpen={isOpenAttachments.isOpen}
        files={isOpenAttachments.files}
        handleClose={() => {
          setIsOpenAttachments({ isOpen: false, files: [] })
        }}
      />
      <StatusModal
        onCheck={({ returnInfo, comment, newStatus }) => {
          handleStatusChangeWOAction(returnInfo, newStatus, comment)
        }}
        isOpen={statusWOAction.isOpen}
        handleClose={() => {
          setStatusWOAction((prev) => ({
            ...prev,
            isOpen: false,
          }))
        }}
        returnInfo={statusWOAction.returnInfo}
        newStatus={statusWOAction.newStatus}
      />
      <DecitionsModal
        returnInfo={confirmationData}
        isOpen={isOpenChange.isOpen}
        decition={isOpenChange.decition}
        onCheck={onCheckStatusChange}
        handleClose={() =>
          setIsOpenChange({
            isOpen: false,
            decition: true,
          })
        }
      />
      <RefundModal
        isOpen={isOpenRefundModal.isOpen}
        data={isOpenRefundModal.data}
        handleClose={() => setIsOpenRefundModal({ isOpen: false, data: {} })}
        secondRefundOption={refundPayments.find((item) => item.uniqueId === 2)}
        showDialogAlert={showDialogAlert}
      />
    </MuiPickersUtilsProvider>
  )
}

export default Returns
